<div class="grid-wrapper" #gridWrapper [class.content-fullscreen]="(appWrapperService.displayContentFullScreen())"
    [class.has-toolbar]="(toolbarService.toolbarVisible$ | async) && !(appWrapperService.displayContentFullScreen())"
    [class.has-infant-menu]="(activeChildMenuItem$ | async)?.children?.length && (infantMenuVisible$ | async) && !(appWrapperService.displayContentFullScreen())">
    @if (!(appWrapperService.displayContentFullScreen())) {
    <div [@fadeInOnEnter] class="header" [class.talking]="(voiceVisual.level$() | async) > 0"
        [class.light]="!(themeService.isDarkMode$ | async)"
        [class.box-shadow-enabled]="(themeService.boxShadowsEnabled$ | async) && !(toolbarService.toolbarVisible$ | async)"
        [class.border-bottom]="(themeService.boxShadowsEnabled$ | async) || (toolbarService.toolbarVisible$ | async)"
        [class.loading]="appWrapperService.isGlobalLoading()" #header>
        <div style="display: flex; flex-direction: row; justify-content: start; align-items: center; z-index: 1;">
            <div style="padding: 16px;" (click)="activateAIAssistant()">
                <svg viewBox="15.976 164.059 473.675 171.883" width="140" xmlns="http://www.w3.org/2000/svg">
                    <g transform="matrix(1.755965, 0, 0, 1.755965, -12.077311, -178.935715)" [ngStyle]="getLogoStyle()">
                        <path
                            d="M 140.026 267.84 L 135.534 267.84 L 135.534 237.396 L 125.329 267.84 L 121.081 267.84 L 110.876 237.396 L 110.876 267.84 L 106.384 267.84 L 106.384 232.049 L 113.488 232.049 L 123.181 261.883 L 132.922 232.049 L 140.026 232.049 Z M 181.674 267.84 L 177.182 267.84 L 177.182 237.396 L 166.976 267.84 L 162.728 267.84 L 152.523 237.396 L 152.523 267.84 L 148.031 267.84 L 148.031 232.049 L 155.136 232.049 L 164.828 261.883 L 174.569 232.049 L 181.674 232.049 Z M 203.179 268.45 Q 195.611 268.45 191.863 265.057 Q 188.116 261.663 187.921 256.341 L 192.486 256.341 Q 192.852 260.345 195.818 262.261 Q 198.785 264.178 202.984 264.178 Q 206.964 264.178 209.393 262.542 Q 211.822 260.906 211.822 258.099 Q 211.822 255.145 209.307 253.802 Q 206.793 252.459 200.652 251.153 Q 194.512 249.847 191.839 247.528 Q 189.166 245.208 189.166 241.351 Q 189.166 237.005 192.645 234.222 Q 196.124 231.439 201.885 231.439 Q 207.94 231.439 211.651 234.246 Q 215.362 237.054 215.582 242.181 L 210.967 242.181 Q 210.259 235.687 202.081 235.687 Q 198.126 235.687 195.953 237.176 Q 193.78 238.665 193.78 241.131 Q 193.78 243.377 195.526 244.5 Q 197.271 245.623 202.044 246.673 Q 206.817 247.723 209.625 248.748 Q 212.432 249.774 214.434 251.934 Q 216.436 254.095 216.436 257.733 Q 216.436 262.347 212.762 265.399 Q 209.088 268.45 203.179 268.45 Z M 241.533 253.192 L 235.234 236.59 L 229.228 253.192 Z M 252.422 267.84 L 247.075 267.84 L 242.925 256.951 L 227.934 256.951 L 223.979 267.84 L 218.974 267.84 L 232.719 232.049 L 237.822 232.049 Z M 269.877 268.45 Q 262.309 268.45 258.561 265.057 Q 254.813 261.663 254.618 256.341 L 259.184 256.341 Q 259.55 260.345 262.516 262.261 Q 265.482 264.178 269.682 264.178 Q 273.661 264.178 276.09 262.542 Q 278.519 260.906 278.519 258.099 Q 278.519 255.145 276.005 253.802 Q 273.49 252.459 267.35 251.153 Q 261.21 249.847 258.537 247.528 Q 255.863 245.208 255.863 241.351 Q 255.863 237.005 259.342 234.222 Q 262.821 231.439 268.583 231.439 Q 274.638 231.439 278.349 234.246 Q 282.059 237.054 282.279 242.181 L 277.665 242.181 Q 276.957 235.687 268.778 235.687 Q 264.823 235.687 262.65 237.176 Q 260.477 238.665 260.477 241.131 Q 260.477 243.377 262.223 244.5 Q 263.969 245.623 268.742 246.673 Q 273.515 247.723 276.322 248.748 Q 279.13 249.774 281.132 251.934 Q 283.134 254.095 283.134 257.733 Q 283.134 262.347 279.459 265.399 Q 275.785 268.45 269.877 268.45 Z"
                            transform="matrix(1, 0, 0, 1.174073, 0, -49.247807)" />
                        <path
                            d="M 66.794 243.325 L 56.452 218.94 L 46.591 243.325 L 66.794 243.325 Z M 84.673 264.842 L 75.894 264.842 L 69.079 248.848 L 44.466 248.848 L 37.973 264.842 L 29.755 264.842 L 52.323 212.269 L 60.701 212.269 L 84.673 264.842 Z" />
                        <path
                            d="M 57.235 195.331 L 15.976 219.802 L 15.976 268.745 L 57.235 293.216 L 98.494 268.745 L 98.494 219.802 L 57.235 195.331 Z M 34.65 227.96 L 57.235 200.251 L 78.684 227.96 L 34.65 227.96 Z M 79.062 230.549 L 57.235 270.687 L 34.271 230.549 L 79.062 230.549 Z M 54.837 271.463 L 19.887 265.637 L 32.252 232.103 L 54.837 271.463 Z M 81.081 232.232 L 94.582 265.767 L 59.632 271.593 L 81.081 232.232 Z M 81.46 227.571 L 60.515 200.251 L 94.582 220.45 L 81.46 227.571 Z M 31.748 227.571 L 19.887 220.45 L 53.702 200.381 L 31.748 227.571 Z M 30.485 229.772 L 18.499 262.141 L 18.499 222.651 L 30.485 229.772 Z M 55.973 274.312 L 55.973 289.461 L 20.518 268.485 L 55.973 274.312 Z M 58.497 274.312 L 93.951 268.485 L 58.497 289.461 L 58.497 274.312 Z M 82.848 229.772 L 96.096 222.521 L 96.096 262.53 L 82.848 229.772 Z" />
                    </g>
                </svg>
            </div>
            @if ((toolbarService.toolbarVisible$ | async) && !(mediaQuery.isMobile$ | async) &&
            !(appWrapperService.displayContentFullScreen())) {
            <app-toolbar #toolbar></app-toolbar>
            }
        </div>
        @if ((bandService.selectedBandId$ | async)) {
        <div style="z-index: 1;">
            <div (click)="overlay.toggle($event)" style="cursor: pointer;">
                @if (mediaQuery.isMobile$ | async) {
                <band-id-card [band]="bandService.selectedBand$ | async" [avatarSize]="'normal'" [showEmail]="false"
                    [showName]="false"></band-id-card>
                }
                @if (!(mediaQuery.isMobile$ | async)) {
                <band-id-card [band]="bandService.selectedBand$ | async" [avatarSize]="'large'" [showEmail]="true"
                    [showName]="true"></band-id-card>
                }
            </div>
        </div>
        }
        @if (!(bandService.selectedBandId$ | async)) {
        <div style="z-index: 1;">
            <div (click)="navigateToSettings()" style="cursor: pointer;">
                @if (mediaQuery.isMobile$ | async) {
                <member-id-card [user]="authService.user$ | async" [avatarSize]="'normal'" [showEmail]="false"
                    [showPhone]="false" [showName]="false"></member-id-card>
                }
                @if (!(mediaQuery.isMobile$ | async)) {
                <member-id-card [user]="authService.user$ | async" [avatarSize]="'large'" [showEmail]="true"
                    [showPhone]="false" [showName]="true"></member-id-card>
                }
            </div>
        </div>
        }
        <div (click)="networkStatusPopover.toggle($event)" class="network-status-indicator"
            [class.error]="networkStatusService.connectionIssues$ | async">
            @if ((outboxService.count$ | async) > 0) {
            <p-badge [style]="{'position': 'absolute', 'left': '0px', 'top': '0px'}"
                [value]="(outboxService.count$ | async)"></p-badge>
            }
            <i class="pi pi-sitemap"></i>
            @if (networkStatusService.connectionIssues$ | async) {
            <span class="network-error">
                <i class="pi pi-exclamation-triangle"></i>
            </span>
            }
        </div>
        <div style="padding: 16px">
            <p-button icon="pi pi-bars" (click)="menu.toggle($event);"></p-button>
            <p-menu #menu [model]="mainMenuItems$ | async" [popup]="true" [autoZIndex]="true" [baseZIndex]="10000"
                [appendTo]="'body'">
                <ng-template pTemplate="item" #item let-item>
                    <a (click)="selectTopMenuItem(item)" class="p-menu-item-link"
                        [ngClass]="{ 'active': isActiveTopMenuItem(item) }">
                        <span [class]="item.icon"></span>
                        <span class="ml-2">{{ item.label | translate }}</span>
                    </a>
                </ng-template>
                <ng-template pTemplate="end">
                    <div style="padding: 8px">
                        <p-button [style]="{'width': '100%'}" severity="secondary" icon="pi pi-sign-out" pRipple
                            [label]="'APP.LOGOUT' | translate" (click)="authService.logout()"></p-button>
                    </div>
                </ng-template>
            </p-menu>
        </div>
    </div>
    }
    @if (!(appWrapperService.displayContentFullScreen())) {
    <div [@fadeInOnEnter] [class.talking]="(voiceVisual.level$() | async) > 0" class="app-navigation"
        [class.light]="!(themeService.isDarkMode$ | async)"
        [class.box-shadow-enabled]="(themeService.boxShadowsEnabled$ | async)"
        [class.loading]="appWrapperService.isGlobalLoading()">
        @for (child of (activeTopMenuItem$ | async)?.children; track child.label) {
        @if (!(hideChildren$ | async)) {
        <a class="submenu-item" [class.box-shadow-enabled]="(themeService.boxShadowsEnabled$ | async)"
            (click)="selectChildMenuItem(child)" [ngClass]="{ 'active': isActiveChildMenuItem(child) }">
            @if (!(child.newsCount | async)) {
            <i [class]="child.icon" style="font-size: 1.5rem;"></i>
            }
            @if (child.newsCount | async) {
            <app-overlay-badge [value]="child.newsCount | async">
                <i [class]="child.icon" style="font-size: 1.5rem;" [@pulseOnChange]="child.newsCount | async"></i>
            </app-overlay-badge>
            }
        </a>
        }
        }
    </div>
    }
    @if ((activeChildMenuItem$ | async)?.children?.length && (infantMenuVisible$ | async) &&
    !(appWrapperService.displayContentFullScreen())) {
    <div class="infant-menu">
        @for (child of (activeChildMenuItem$ | async)?.children; track child.label) {
        @if (!(hideChildren$ | async)) {
        <a [routerLink]="child.routerLink" [class.box-shadow-enabled]="(themeService.boxShadowsEnabled$ | async)"
            class="submenu-item" routerLinkActive="active" (click)="selectInfantMenuItem(child)">
            <i [class]="child.icon" style="font-size: 1.5rem;"></i>
        </a>
        }
        }
    </div>
    }

    @if ((toolbarService.toolbarVisible$ | async)
    && (mediaQuery.isMobile$ | async)
    && !(appWrapperService.displayContentFullScreen())) {
    <app-toolbar [class.border-bottom]="themeService.boxShadowsEnabled$ | async"
        [class.box-shadow-enabled]="(themeService.boxShadowsEnabled$ | async)" #toolbar>
    </app-toolbar>
    }

    <main class="main-area" #main>
        <p-toast [style]="{'top': '68px'}" position="top-center" key="tc" />
        <router-outlet #mainOutlet></router-outlet>
    </main>

</div>

<p-popover [appendTo]="'body'" #overlay>
    <div style="min-width: 300px;">
        <ol class="band-members-list">
            <li style="    padding: 16px; padding-left: 0px;">
                <band-id-card [band]="bandService.selectedBand$ | async"></band-id-card>
            </li>
            @for (member of bandService.bandMembers$ | async; track member.id) {
            <li>
                <member-id-card [member]="member"></member-id-card>
            </li>
            }
        </ol>
    </div>
</p-popover>
<p-popover [appendTo]="'body'" #networkStatusPopover (onShow)="onNetworkPopoverShown()"
    (onHide)="onNetworkPopoverHidden()">
    <div style="min-width: 300px;">
        <div class="network-status-content">
            <h3>Network Status</h3>
            <div class="network-status-details">
                <div>
                    <h4>Internet</h4>
                </div>
                <div style="display: flex; align-items: center; gap: 8px;">
                    <i class="pi pi-globe"></i>
                    <app-cardiogram [status]="(networkStatusService.networkStatus$ | async).connected"></app-cardiogram>
                    <div>
                        @if ((networkStatusService.networkStatus$ | async).connected) {
                        <p>
                            Status: Connected
                        </p>
                        }
                        @if (!(networkStatusService.networkStatus$ | async).connected) {
                        <p>
                            Status: Disconnected
                        </p>
                        }
                        <p>Connection Type: {{ (networkStatusService.networkStatus$ | async).connectionType }}</p>
                    </div>
                </div>
            </div>
            <div class="network-status-details">
                <div>
                    <h4>AMMSAS Server</h4>
                </div>
                <div style="display: flex; align-items: center; gap: 8px;">
                    <i class="pi pi-server"></i>
                    <app-cardiogram [status]="(networkStatusService.networkStatus$ | async).connected"></app-cardiogram>
                    <div>
                        @if ((networkStatusService.networkStatus$ | async).connected) {
                        <p>
                            Status: Connected
                        </p>
                        }
                        @if (!(networkStatusService.networkStatus$ | async).connected) {
                        <p>
                            Status: Disconnected
                        </p>
                        }
                        <p>eu-central Falkenstein</p>
                        <p>ammsas-server 1.0.0-alpha23</p>
                    </div>
                </div>
            </div>

            <div class="network-status-details">
                <div>
                    <h4>Socket IO</h4>
                </div>
                <div style="display: flex; align-items: center; gap: 8px;">
                    <i class="pi pi-arrow-right-arrow-left"></i>
                    <app-cardiogram [status]="(networkStatusService.webSocketStatus$ | async)"></app-cardiogram>
                    <div>
                        @if ((networkStatusService.webSocketStatus$ | async)) {
                        <p>
                            Status: Connected
                        </p>
                        }
                        @if (!(networkStatusService.webSocketStatus$ | async)) {
                        <p>
                            Status: Disconnected
                        </p>
                        }
                    </div>
                </div>
            </div>

            @if ((outboxService.count$ | async) > 0) {
            <div class="network-status-details">
                <h4>Outbox</h4>
                <div style="display: flex; align-items: center; gap: 8px;">
                    <i class="pi pi-database"></i>
                    <app-cardiogram style="visibility: hidden;"
                        [status]="(networkStatusService.webSocketStatus$ | async)"></app-cardiogram>
                    <div>
                        <div style="display: flex; align-items: center; gap: 8px; justify-content: center;">
                            <p-button styleClass="p-button-text" [icon]="'pi pi-trash'"
                                (click)="outboxService.deleteQueue()"></p-button>
                            <p-button styleClass="p-button-text" [icon]="'pi pi-sync'"
                                (click)="outboxService.sync()"></p-button>
                        </div>
                        @if ((outboxService.count$ | async) > 0) {
                        <p>
                            Unsynced Processes: {{outboxService.count$ | async}}
                        </p>
                        }
                    </div>
                </div>
            </div>
            }

        </div>
    </div>
</p-popover>

<p-confirmdialog />